import React, { Fragment, useState, useEffect } from 'react';
import NavbarS2 from '../../components/NavbarS2/NavbarS2'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import ServiceSidebar from './sidebar'
import Footer from '../../components/footer/Footer';
import logo from '../../images/logo-2.svg'

const ServiceSinglePage = (props) => {
    const { slug } = useParams()
    const [serviceDetails, setServiceDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchService = async () => {
            try {
                // Fetch all services and find by slug
                const res = await fetch('/api/services');
                const data = await res.json();
                const service = Array.isArray(data) ? data.find(s => s.slug === slug) : null;
                if (service && service.features) {
                    try {
                        service.features = JSON.parse(service.features);
                    } catch (e) {
                        service.features = [];
                    }
                }
                setServiceDetails(service);
            } catch (error) {
                console.error('Error fetching service:', error);
                setServiceDetails(null);
            } finally {
                setLoading(false);
            }
        };
        fetchService();
    }, [slug]);

    if (loading) {
        return (
            <Fragment>
                <NavbarS2 hclass={'wpo-site-header'} Logo={logo} />
                <PageTitle pageTitle="Loading..." pagesub={'Services'} />
                <section className="service-single-page section-padding">
                    <div className="container">
                        <div style={{ textAlign: 'center', padding: '60px' }}>Loading service details...</div>
                    </div>
                </section>
                <Footer />
                <Scrollbar />
            </Fragment>
        );
    }

    if (!serviceDetails) {
        return (
            <Fragment>
                <NavbarS2 hclass={'wpo-site-header'} Logo={logo} />
                <PageTitle pageTitle="Service Not Found" pagesub={'Services'} />
                <section className="service-single-page section-padding">
                    <div className="container">
                        <div style={{ textAlign: 'center', padding: '60px' }}>Service not found.</div>
                    </div>
                </section>
                <Footer />
                <Scrollbar />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <NavbarS2 hclass={'wpo-site-header'} Logo={logo} />
            <PageTitle pageTitle={serviceDetails.title} pagesub={'Services'} />
            <section className="service-single-page section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12 order-lg-2">
                            <div className="service-single-wrap">
                                <h2>{serviceDetails.title}</h2>
                                <p>{serviceDetails.page_intro || serviceDetails.description}</p>
                                <h3>{serviceDetails.section_title || 'About This Service'}</h3>
                                <p>{serviceDetails.section_content || ''}</p>
                                <div className="video-wrap">
                                    <div className="video-content" style={{width: '100%'}}>
                                        <h2>{serviceDetails.highlight_title || ''}</h2>
                                        <p>{serviceDetails.highlight_content || ''}</p>
                                        <ul>
                                            {Array.isArray(serviceDetails.features) && serviceDetails.features.map((feature, index) => (
                                                <li key={index}>{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <h3 className="quate">{serviceDetails.quote || ''}</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 order-lg-1">
                            <ServiceSidebar/>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;



